import { S } from "../styles";

export function StatCard({
  label,
  value,
  sub,
  color,
}: {
  label: string;
  value: string;
  sub?: string;
  color?: string;
}) {
  return (
    <div
      style={{
        ...S.card,
        marginBottom: 0,
        padding: "18px 18px",
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          color: "#94a3b8",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 26,
          fontWeight: 800,
          letterSpacing: "-0.02em",
          lineHeight: 1.1,
          color: color ?? "#0f172a",
        }}
      >
        {value}
      </div>
      {sub && <div style={{ ...S.muted, fontSize: 12 }}>{sub}</div>}
    </div>
  );
}
